import {
  CustomIntegrationSettingsType,
  IntegrationEnum,
} from 'models/InternalIntegrationSetting';
import { Link } from 'react-router-dom';
import { Trans, useTranslation } from 'react-i18next';
import useFetchIntegrationAgencySettings from 'hooks/useFetchIntegrationAgencySettings';
import { HostfullyLinkContainer } from './IntegrationCell.styles';

const AccessLink = ({ integrationId }: { integrationId: IntegrationEnum }) => {
  const { t } = useTranslation();

  const isHostfullyProduct = [
    IntegrationEnum.HOSTFULLYDEVICES,
    IntegrationEnum.HOSTFULLYCAPITAL,
    IntegrationEnum.HOSTFULLY,
  ].includes(integrationId);

  const { data: integrationSettings, isLoading } =
    useFetchIntegrationAgencySettings({
      enumId: integrationId,
      enabled: isHostfullyProduct,
    });

  const getAccessLink = () => {
    const { agencySettings } = integrationSettings ?? {};

    switch (agencySettings?.customIntegrationSettings?.type) {
      case CustomIntegrationSettingsType.HOSTFULLY_GUIDEBOOKS:
      case CustomIntegrationSettingsType.HOSTFULLY_CAPITAL:
      case CustomIntegrationSettingsType.HOSTFULLY_DEVICES:
        return agencySettings?.customIntegrationSettings?.accessUrl ?? '';
      default:
        return '';
    }
  };

  const linkLabelMap = {
    [IntegrationEnum.HOSTFULLY]: t('pageIntegrations.table.guidebooksAdmin'),
    [IntegrationEnum.HOSTFULLYCAPITAL]: t(
      'pageIntegrations.table.hostfullyCapital',
    ),
    [IntegrationEnum.HOSTFULLYDEVICES]: t(
      'pageIntegrations.table.devicesAdmin',
    ),
  };

  const label = linkLabelMap[integrationId as keyof typeof linkLabelMap];
  const link = getAccessLink();

  if (!isHostfullyProduct || isLoading || !link) {
    return null;
  }

  return (
    <HostfullyLinkContainer>
      <Trans
        i18nKey="pageIntegrations.table.accessLink"
        values={{ label }}
        components={{
          1: (
            <Link
              to={link}
              target="_blank"
              rel="noreferrer"
              aria-label="Access link"
              data-testid="access-link-hostfully-integration"
            />
          ),
        }}
      />
    </HostfullyLinkContainer>
  );
};

export default AccessLink;
